// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1cXWD","label":"CategoryService_label__3YeJu","location":"CategoryService_location__3MAXN"};